module.exports = __webpack_public_path__ + "img/svg_salesRegistration.2620fbc3.svg";